import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { CssBaseline, Stack, IconButton } from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import ThurentEventForm from "../redesign/components/ThurentEventForm";
import './Eventspage_module.css'
import ProviderServices from "./ProviderServices";
import { homePagePath } from "../constant";
import { fetchAllEventCategoriesWithEvents } from "../Apiservices/Auth/servers/fetchCategoryEvents";
import EventForm from "./eventComponent/EventForm2";
import { Dialog } from "primereact/dialog";
import { useTransition } from "react";
import Navbar from "../redesign/components/Navbar";
import Footer from "../redesign/components/Footer";
import MyButton1 from "./CustomComponents/MyButton1";
import { eventbasedseomapping } from "../redesign/components/Services/seoMappings";

export const Eventspage = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const { slug } = useParams();
  const seoData = eventbasedseomapping.default; 
  const [event, setEvent] = useState();
  const [eventCategories, setEventCategories] = useState([]);

  const [visible, setVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();

  const [isPending, startTransition] = useTransition();

  const loadEventCategories = async () => {
    startTransition(async () => {
      const response = await fetchAllEventCategoriesWithEvents();
      if (response) {
        setEvent(
          response?.find(
            (event) => event.name?.toLowerCase()?.replaceAll(" ", "-") === slug
          )
        );
        setEventCategories(response);
      }
    });
  };

  useEffect(() => {
    loadEventCategories();
  }, []);

  useEffect(() => {
    setEvent(
      eventCategories?.find(
        (event) => event.name?.toLowerCase()?.replaceAll(" ", "-") === slug
      )
    );
  }, [slug]);

  const backtoHome = () => {
    isLoggedIn ? navigate("/dashboard") : navigate(homePagePath);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [slug]);
  const renderWithSpacingAndColor = (desc) => {
    if (!desc) return null;
  
    // Split into sentences by '. '
    const sentences = desc.split('. ').filter(Boolean);
  
    // Total words count for coloring
    const words = desc.split(' ');
    const halfway = Math.floor(words.length / 2);
  
    let wordCount = 0;
  
    return (
      <>
        {sentences.map((sentence, idx) => {
          const sentenceWords = sentence.split(' ');
          const firstHalfWords = [];
          const secondHalfWords = [];
  
          sentenceWords.forEach(word => {
            if (wordCount < halfway) firstHalfWords.push(word);
            else secondHalfWords.push(word);
            wordCount++;
          });
  
          // Return multiple lines inside each sentence wrapped by <div> with margin
          return (
            <div key={idx} style={{ marginBottom: '20px' }}>
              {/* Wrap first half words in span */}
              <span>{firstHalfWords.join(' ')}</span>{' '}
              {/* Wrap second half words in colored span */}
              <span style={{ color: 'var(--primary-blue-color)' }}>
                {secondHalfWords.join(' ')}
              </span>
              {idx < sentences.length - 1 && '.'}
            </div>
          );
        })}
      </>
    );
  };
  
  return (
    <div style={{ width: "100%" }}>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      <CssBaseline />
      <Navbar/>
      <div className={`main-container-eventpage ${!isLoggedIn && "no-auth"}`}>
        <div className="frontend-containe-eventspager">
          <div style={{ width: "100%", paddingBottom: "30px" }}>
            {isPending || !event || !eventCategories ? (
              <h3 style={{ textAlign: "center" }}>
                <i
                  className="pi pi-spin pi-spinner-dotted"
                  style={{ fontSize: "2rem", color: "#0cc0df" }}
                ></i>
              </h3>
            ) : (
              <>
                <div className="event-form-inner-eventspage">

                  <div className="event-form-body-events-page list">
                    <div className="event-form-body-inner-eventspage">
                    
                      <div className="event-form-head-eventpage">
                        <div className="event-service-head-inner-eventspage">
                         
                          <div>
                          <h1>
                            <span className="header-black">
                              {event?.name}
                              <br />
                              {renderWithSpacingAndColor(event?.shortDescription)}
                            </span>
                          </h1>



                            <div className="event-rsvp-eventspage">
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: event?.longDescription,
                        }}
                        style={{
                          paddingBottom: "30px",
                        }}
                      ></div>

                          
                      <div className="middle-content-service-eventspages">
                       
                       <div style={{display:"flex"}}>
                        <h1 className="header-blue">
                          {event.name.toLowerCase()=="funeral"?
                           <span>{event.name} ?</span>:
                          <span>What {event.name} are you Celebrating?</span> }                        
                        </h1>
                         <div  className="back-to-home">
                               <MyButton1 title="Back To Home" method={backtoHome}/>
                               </div>  
                        </div> 

                        <div className="event-service-eventspage-container-box">
                        {event?.events?.map((event) => (                         
                            <div
                              className="event-service-eventspage-container"
                              onClick={() => {
                                setVisible(true);
                                setSelectedEvent(event);
                              }}
                            >
                              <div className="event-service-head-eventspage">
                                <div>
                                  <div>
                                    <h3>{event.name}</h3>
                                  </div>
                                  
                                </div>
                                {/* <div className="pi pi-chevron-right"></div> */}
                              </div>
                            </div>
                          
                        ))}
                        </div>
                      </div>
                      <Dialog
                        visible={visible}
                        onHide={() => setVisible(false)}
                        header={<>Create event for {selectedEvent?.name}</>}
                      >
                        <EventForm
                          preSelectedEvent={selectedEvent}
                          onCloseDailog={() => {
                            setVisible(false);
                            navigate("/dashboard");
                          }}
                        />
                      </Dialog>
                    </div>
                    <div className="event-service-list-eventspage sidebar">                     
                      <div classname="create-event-form-eventpage">
                        <ThurentEventForm />
                      </div>
                      <div className="Events-service-display">
                        <h3 style={{color:"black",paddingBottom:"30px"}}>Not Sure What Your Event Is? Find It Here!</h3>
                        <div className="event-category-wrapper">
                          {eventCategories.length > 0 &&
                            eventCategories
                              .filter((item) => item.id !== event?.id)
                              // .slice(0, 4)
                              .map((item) => (
                                <Link
                                  key={item.id}
                                  className="event-service-eventspage sel-event"
                                  to={`/event/${item.name
                                    ?.toLowerCase()
                                    ?.replaceAll(" ", "-")}`}
                                >
                                  <div className="event-service-head-eventspage">
                                    <div>
                                      <div>
                                        
                                        <span className="th-nav__auth">{item.name}</span>
                                        {/* <div className="event-rsvp-eventspage">
                                          {item.shortDescription}
                                        </div> */}
                                      </div>
                                    </div>
                                    {/* <div className="pi pi-chevron-right"></div> */}
                                  </div>
                                </Link>
                              ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ProviderServices />
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <ConfirmDialog />
    </div>
  );
};
export default Eventspage;
